import { Schemas } from 'src/openapi/generated/types';
import { ReservationFlowInvalidRequestError } from 'src/interfaces/reservation_flow';

import { filterReservationFlowInvalidRequestDetails } from '../filter-reservation-flow-invalid-request-details';

export const getInvalidPaymentMethodItems: (
  error: ReservationFlowInvalidRequestError,
) => Schemas.ReservationFlowInvalidRequestItem[] = (error) => {
  const { details } = error;

  // MEMO: クレジット更新停止用のエラー(credit_card_update_unavailable)はinvalid_payment_methodと同系列のエラーとして分類されているのでこちらに追加する
  return filterReservationFlowInvalidRequestDetails(details)
    .map((detail) => {
      return detail.invalid_items.filter(
        (item) =>
          item.type === 'invalid_payment_method' ||
          item.type === 'credit_card_update_unavailable' ||
          item.type === 'end_user_no_profile',
      );
    })
    .flat() as Schemas.ReservationFlowInvalidRequestItem[];
};
